/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {GamesStateInterface} from '@/store/modules/games/types';
import {actions} from '@/store/modules/games/actions';
import {getters} from '@/store/modules/games/getters';
import {mutations} from '@/store/modules/games/mutations';


export const state: GamesStateInterface = {
    games: [],
    currentGame: undefined,
    platforms: [],
    error: false,
    currentGameVersion: null,
};

const namespaced: boolean = true;

export const gamesStateModule: Module<GamesStateInterface, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
};
